<template>

    <div>
        <div class="row">
            <div class="col-12">
                <div class="form-group mb-2">
                    <label class="required">{{ $t('parameters.form.names.subcategory') }}</label>
                    <div class="custom-radio-lg custom-radio-lg--inline">
                        <div v-for="(houseTypeValue,index) in houseType.values"
                             class="custom-control custom-radio custom-checkbox-lg__item"
                        >
                            <input type="radio" :id="'house_type-' + houseTypeValue.id"
                                   name="reproduction-houseType"
                                   v-model="houseTypesModel"
                                   :value="'house_type-' + houseTypeValue.id"
                                   class="custom-control-input"
                                   @change="updateValue($event.target.value)"
                                   required
                            >
                            <label class="custom-control-label mr-0"
                                   :for="'house_type-' + houseTypeValue.id"
                            >
                                {{ $t('parameters.form.house_subtype.' + houseTypeValue.id) }}
                            </label>
                            <i class="fas fa-question-circle text-primary mr-3"
                               data-toggle="modal"
                               :data-target="'#modal-house_type-' + houseTypeValue.id"
                            ></i>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- Modal -->
        <reproduction-help-modal :houseTypesModel="houseTypesModel"
                             :propertyTypeModel="propertyTypeModel"></reproduction-help-modal>
    </div>


</template>

<script>
import ReproductionHelpModal from "./reproductionHelpModal.vue";

export default {
    name: 'ReproductionSubtype',
    components: {ReproductionHelpModal},
    props: {
        propertyTypeModel: {
            type: String,
            required: true,
        },
        oldSubType: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            houseTypesModel: 'house_type-individual',
            houseTypes: [
                {
                    id: 'apartment_house',
                    values: [
                        {
                            id: 'unified_panel',
                            name: 'Panelový',
                        },
                        {
                            id: 'unified_other',
                            name: 'Typový',
                        },
                        {
                            id: 'atypical',
                            name: 'Netypový',
                        }
                    ],
                },
                {
                    id: 'family_house',
                    values: [
                        {
                            id: 'individual',
                            name: 'Samostatný',
                        },
                        {
                            id: 'semi_detached',
                            name: 'Dvojdomek',
                        },
                        {
                            id: 'row_house',
                            name: 'Řadový',
                        },
                    ],
                },
                {
                    id: 'recreational',
                    values: [
                        {
                            id: 'hut',
                            name: 'Chata',
                        },
                        {
                            id: 'cottage',
                            name: 'Chalupa',
                        },
                    ],
                },
            ],
            houseType: null,
            houseTypeVal: null
        }
    },
    created() {
        let currentProp = this.propertyTypeModel;
        if (currentProp === 'property_type-apartment_house') {
            this.houseType = this.houseTypes[0];
        }

        if (currentProp === 'property_type-family_house') {
            this.houseType = this.houseTypes[1];
        }

        if (currentProp === 'property_type-recreational') {
            this.houseType = this.houseTypes[2];
        }
    },
    watch: {
        'propertyTypeModel'() {
            let currentProp = this.propertyTypeModel;
            let houseTypeConst = 'house_type-';
            if (currentProp === 'property_type-apartment_house') {
                this.houseType = this.houseTypes[0];
                let value = this.oldSubType !== '' && this.isSubTypeAllowed()
                    ? this.oldSubType
                    : this.houseType.values[0].id;
                this.houseTypesModel = houseTypeConst + value;
            }

            if (currentProp === 'property_type-family_house') {
                this.houseType = this.houseTypes[1];
                let value = this.oldSubType !== '' && this.isSubTypeAllowed()
                    ? this.oldSubType
                    : this.houseType.values[0].id;
                this.houseTypesModel = houseTypeConst + value;
            }
            //let value = this.oldSubType !== '' ? this.oldSubType : this.houseType.values[0].id;
            // this.houseTypesModel = 'house_type-' + value;

            if (currentProp === 'property_type-recreational') {
                this.houseType = this.houseTypes[2];
                let value = this.oldSubType !== '' && this.isSubTypeAllowed()
                    ? this.oldSubType
                    : this.houseType.values[0].id;
                this.houseTypesModel = houseTypeConst + value;
            }
        }
    },
    mounted() {
        if (this.oldSubType !== '') {
            this.houseTypesModel = 'house_type-' + this.oldSubType;
        }
    },
    methods: {
        isSubTypeAllowed() {
            let currentHouseTypeObj = this.houseTypes.filter(type => {
                let propType = this.propertyTypeModel.replace('property_type-', '');
                return type.id === propType;
            });

            if (currentHouseTypeObj.length === 0) {
                return false;
            }

            let subTypeAvailable = currentHouseTypeObj[0].values.find(subtype => {
                return subtype.id === this.oldSubType;
            });

            return subTypeAvailable !== undefined;
        },
        updateValue: function (value) {
            this.$emit('update:value', value);
        }
    }
}
</script>
